import api from "./client";

export type IecPrExclusionInput = {
  start_time: string;
  end_time: string;
  exclusion_type: string;
  exclusion_scope: "site" | "section";
  section_key?: string;
  reason: string;
};

export type IecPrRunRequest = {
  site_id: number;
  report_date: string;
  apply_clipping_correction: boolean;
  apply_curtailment_correction: boolean;
  apply_availability_correction: boolean;
  irradiance_threshold_wm2: number;
  contract_method_name?: string;
  contract_method_notes?: string;
  notes?: string;
  force_recompute?: boolean;
  exclusions: IecPrExclusionInput[];
};

export const getIecPrConfigPreview = async (siteId: number | string, reportDate?: string) => {
  const { data } = await api.get(`/reports/iec/sites/${siteId}/config-preview`, {
    params: reportDate ? { report_date: reportDate } : undefined,
  });
  return data;
};

export const createIecPrRun = async (payload: IecPrRunRequest) => {
  const { data } = await api.post("/reports/iec/runs", payload);
  return data;
};

export const listIecPrRuns = async (siteId: number | string, reportDate?: string) => {
  const { data } = await api.get(`/reports/iec/sites/${siteId}/runs`, {
    params: reportDate ? { report_date: reportDate } : undefined,
  });
  return data;
};

export const getIecPrRun = async (runId: number | string) => {
  const { data } = await api.get(`/reports/iec/runs/${runId}`);
  return data;
};

export const getIecPrReportPayload = async (runId: number | string) => {
  const { data } = await api.get(`/reports/iec/runs/${runId}/report`);
  return data;
};

export const getIecPrExclusions = async (runId: number | string) => {
  const { data } = await api.get(`/reports/iec/runs/${runId}/exclusions`);
  return data;
};

export const getIecPrMinutes = async (runId: number | string, limit = 100, offset = 0) => {
  const { data } = await api.get(`/reports/iec/runs/${runId}/minutes`, { params: { limit, offset } });
  return data;
};

export const downloadIecPrCsv = async (runId: number | string) => {
  const response = await api.get(`/reports/iec/runs/${runId}/export.csv`, {
    responseType: "blob",
  });
  return response;
};
